export class Attribute {
    id: string
    status: string
    title: Map<string,string>
    iconIds: Map<string,string>
    dndDisableIf= true
}
